/**
 * WalletIcon — sanitized from `assets/newSvg/wallet.svg`.
 * Artboard: 1024×1024 · viewBox 0 0 24 24 (fixed).
 */
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import {
  APP_ICON_VIEW_BOX,
  useAppIconProps,
  type AppIconProps,
} from './iconBase';

export function WalletIcon(props: AppIconProps) {
  const { size, color, style, accessibilityLabel, testID, ...rest } = useAppIconProps(props);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={APP_ICON_VIEW_BOX}
      style={style}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      {...rest}
    >
      <Path
        d="M19,4 C20.1046,4 21,4.89543 21,6 L21,7 L15,7 C12.2386,7 10,9.23858 10,12 C10,14.7614 12.2386,17 15,17 L21,17 L21,18 C21,19.1046 20.1046,20 19,20 L5,20 C3.89543,20 3,19.1046 3,18 L3,6 C3,4.89543 3.89543,4 5,4 L19,4 Z M20,9 C21.1046,9 22,9.89543 22,11 L22,13 C22,14.1046 21.1046,15 20,15 L15,15 C13.3431,15 12,13.6569 12,12 C12,10.3431 13.3431,9 15,9 L20,9 Z M15,11 C14.4477,11 14,11.4477 14,12 C14,12.5523 14.4477,13 15,13 C15.5523,13 16,12.5523 16,12 C16,11.4477 15.5523,11 15,11 Z"
        fill={color}
      />
    </Svg>
  );
}

export default WalletIcon;
